module.exports = __webpack_public_path__ + "img/benefits-students-3.a658e38e.svg";